module.exports = {"id":"143587","name":"Fernando Belluschi","rating":"80","photo":"./data/images/photos/4/143587.png","club":{"name":"San Lorenzo","logo":"./data/images/clubs/SanLorenzo.png"},"positions":["MOC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FernandoBelluschi0.json
// module id = 1414
// module chunks = 0